import { useEffect } from "react";
import { useAuthStore } from "../../stores/useAuthStore";
import { useScreenStore } from "../../stores/useScreenStore";
import { useOverlayStore } from "../../stores/useOverlayStore";
import { closeFiltersWindow } from "../../utils/filtersWindow";

export function useMonitorModePermissions() {

  const user = useAuthStore(state => state.user);

  const monitorMode = useScreenStore(state => state.monitorMode);

  const setMonitorMode = useScreenStore(state => state.setMonitorMode);

  const setPreferredScreen = useOverlayStore(state => state.setPreferredScreen);

  const preferredScreen = useOverlayStore(state => state.preferredScreen);

  useEffect(() => {

    if (!user) {
      return;
    }

    if (!user.capabilities.canSelectDualMonitor) {
      

        if (monitorMode !== 1) {
            closeFiltersWindow();
            setMonitorMode(1);
        }

        if (preferredScreen !== 'Home') {
            setPreferredScreen('Home');
        }
    }

  }, [user, monitorMode, setMonitorMode, preferredScreen, setPreferredScreen]);

}